import type { ReactNode } from 'react';

export interface PageContainerProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function PageContainer({ children, className = '' }: PageContainerProps): JSX.Element {
  return (
    <div
      className={`mx-auto w-full max-w-[1400px] py-4 sm:py-5 ${className}`}
      style={{
        paddingLeft: 'max(0.75rem, env(safe-area-inset-left))',
        paddingRight: 'max(0.75rem, env(safe-area-inset-right))',
      }}
    >
      {children}
    </div>
  );
}
